import { Panel } from '@/components/Layouts/ContentPanel';
import CreateOrgModal from '@/components/Organizations/CreateOrgModal';
import EditOrgModal from '@/components/Organizations/EditOrgModal';
import { OrgContext } from '@/components/Organizations/OrgContext';
import OrgList from '@/components/Organizations/OrgList';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useContext } from 'react';

export default function OrganizationsPanel() {
  const { setShowModal, setEditFocus, isEdit } = useContext(OrgContext);

  const handleClick = () => {
    setEditFocus('organization');
    setShowModal(true);
  };

  return (
    <>
      <Panel
        title="Organizations"
        headerChildren={
          <button className="btn btn-primary" onClick={handleClick}>
            <FontAwesomeIcon icon={faPlus} className="mr-8" />
            Create Organization
          </button>
        }
      >
        <OrgList />
      </Panel>

      {isEdit ? <EditOrgModal /> : <CreateOrgModal />}
    </>
  );
}
